module.exports = __webpack_public_path__ + "open-sans-light.7c5d9f078bea8c1fc0b2.woff";


//////////////////
// WEBPACK FOOTER
// ./src/assets/css/fonts/google/open-sans-light.woff
// module id = 706
// module chunks = 2